<template>
  <div>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 ts-border-gray-300">
          <div class="row mb-2">
            <label class="required col-md-4 col-form-label">{{
              $t('scoreAssessment.amountDivider')
            }}</label>
            <div class="col-md-8">
              <input
                v-model.number="model.amount_divider"
                type="number"
                step="any"
                class="form-control"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('amount_divider')"
              >
                {{ errors.first('amount_divider') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-md-4 col-form-label"></label>
            <div class="col-md-8">
              <div class="ts-inline-block mr-2">
                <ts-checkbox v-model="model.monthly">{{
                  $t('scoreAssessment.monthly')
                }}</ts-checkbox>
              </div>
              <div class="ts-inline-block">
                <ts-checkbox v-model="model.semesterly">{{
                  $t('scoreAssessment.semesterly')
                }}</ts-checkbox>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-md-4 col-form-label"></label>
            <div class="col-md-8 text-right">
              <ts-button
                :disabled="disable"
                color="danger"
                class="mr-2 btn-xs"
                :waiting="deleting"
                @click.prevent="destroy"
                >{{ $t('delete') }}</ts-button
              >
              <ts-button
                outline
                color="info"
                class="btn-xs"
                :disabled="disable"
                :waiting="waiting"
                @click.prevent="save"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'scoreAssessmentCustomDivider',
  props: ['params'],
  data() {
    return {
      deleting: false,
      waiting: false,
      errors: new Errors(),
      model: {
        sc_setup_id: 0,
        program_structure_id: 0,
        amount_divider: 0,
        monthly: false,
        semesterly: false
      }
    }
  },
  computed: {
    disable() {
      return !this.model.program_structure_id > 0
    }
  },
  methods: {
    save() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('scoreAssessment/storeCustomDivider', this.model)
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    destroy() {
      this.deleting = true
      this.$store
        .dispatch('scoreAssessment/deleteCustomDivider', {
          sc_setup_id: this.model.sc_setup_id,
          program_structure_id: this.model.program_structure_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.deleting = false
        })
    },
    show() {
      this.$store
        .dispatch('scoreAssessment/findCustomDivider', {
          sc_setup_id: this.model.sc_setup_id,
          program_structure_id: this.model.program_structure_id
        })
        .then(response => {
          if (response.data != null) {
            this.model.amount_divider = response.data.amount_divider
            this.model.monthly = response.data.monthly
            this.model.semesterly = response.data.semesterly
          } else {
            this.clearInput()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    clearInput() {
      this.model.amount_divider = 0
      this.model.monthly = false
      this.model.semesterly = false
    }
  },
  watch: {
    params: {
      handler(val) {
        this.model.sc_setup_id = val.sc_setup_id
        this.model.program_structure_id = val.program_structure_id
      },
      deep: true
    },
    'model.program_structure_id': function(val) {
      if (val) {
        this.show()
      } else {
        this.clearInput()
      }
    }
  }
}
</script>
